import { TextInput } from "@hoylu/client-common";
import { clsx } from "clsx";
import React from "react";
import { useSelector } from "react-redux";
import type { RootState } from "typesafe-actions";
import { useI18n } from "../../utils/hooks/use.i18n";
import { useTextInputLocalization } from "../../utils/useTextInputLocalization";
import Styles from "./SearchInput.module.css";

type SearchInputProps = {
  handleChange: (value: string) => void;
  responsive?: boolean;
  searchTerm: string;
};

export const SearchInput = ({
  handleChange,
  responsive = false,
  searchTerm,
}: SearchInputProps) => {
  const t = useI18n("FILTER_BY_NAME.");

  const isLoading = useSelector(
    (state: RootState) => state.context.workspaces.pagination.isFetching,
  );

  return (
    <div className={clsx(Styles.searchInput, responsive && Styles.responsive)}>
      <TextInput
        classNames={[Styles.input]}
        label=""
        localizationDict={useTextInputLocalization()}
        onChange={handleChange}
        useClear
        useMagnifier
        value={searchTerm}
        watermark={t(isLoading ? "LOADING_WORKSPACES" : "SEARCH")}
      />
    </div>
  );
};
